import moment from "moment";
import React, { useEffect, useMemo } from "react";
import { Cell, useBlockLayout, useFilters, useGlobalFilter, usePagination, useRowSelect, useSortBy, useTable } from "react-table";
import { CtBillType } from "src/api/billingSchedule/billing-type";
import { BaseButton, BaseTable } from "src/components";
import InnerTable from "src/components/InnerTable";
import PaymentStatusView from "src/pages/billing/components/PaymentStatusView";
import { numberToStringWithComma, ViewYmdFormat } from "src/utils";

const billingScheduleColumns: any = [
  {
    Header: "청구서명",
    accessor: "billTitle",
    width: 220,
  },
  {
    Header: "청구금액(원)",
    accessor: "totalAmount",
    width: 200,
    Cell: ({ value }: Cell<CtBillType>) => {
      return <p>{numberToStringWithComma(value) + "원"}</p>;
    },
  },
  {
    Header: "결제수단",
    accessor: "pgcode",
    width: 80,
    Cell: ({ value }: Cell<CtBillType>) => {
      return (
        <div>
          {value && value === "virtualaccount" && <p>가상계좌</p>}
          {value && value === "creditcard" && <p>신용카드</p>}
          {value && value === "banktransfer" && <p>계좌이체</p>}
        </div>
      );
    },
  },
  {
    Header: "승인",
    accessor: "isConfirmed",
    width: 80,
    Cell: ({ value }: Cell<CtBillType>) => {
      return (
        <div className={`${String(value) === "true" ? "status F" : "status G"}`}>
          <p>{String(value) === "true" ? "확정" : "미확정"}</p>
        </div>
      );
    },
  },
  {
    Header: "청구서 상태",
    accessor: "billPayStatus",
    width: 120,
    Cell: ({ value, row }: Cell<CtBillType>) => {
      // 연체 표시 : -
      let billIssuDay = moment(row.original.billDueDate).format(ViewYmdFormat.YYYY_MM_DD);
      let today = moment().format(ViewYmdFormat.YYYY_MM_DD);

      if (row.original.billPayStatus === "PAYMENT_READY" && moment(today).isAfter(moment(billIssuDay))) {
        value = "PAYMENT_DELAY";
      }

      return <PaymentStatusView value={value} />;
    },
  },
];

type Props = {
  onClose: () => void;
  onSave: () => void;
  pendingBillList: CtBillType[];
};

const ContractBillingScheduleConfirmModal = ({ onClose, onSave, pendingBillList }: Props) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns: billingScheduleColumns as any,
      data: pendingBillList,
    },
    useBlockLayout,
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
  );

  // columns width 의 총 합 (table witdh 를 구하기 위함)
  const tableWidth = useMemo(() => {
    let totalWidth = 0;
    headerGroups.forEach((headerGroup) => {
      headerGroup.headers.forEach((header) => (totalWidth += Number(header?.width || 0)));
    });
    return totalWidth;
  }, [headerGroups]);

  return (
    <>
      <section className="base-abstract-modal__title">
        <div>
          <h1>이용료 결제 정보를 저장하시겠습니까?</h1>
          <p className="font14 text-primary3 mt10">총 {pendingBillList.length}건의 청구서에 변경사항이 반영됩니다.</p>
        </div>
      </section>

      <section className="base-abstract-modal__contents overflow-x-hidden">
        {/* <article className="contents-container__wrap-article"> */}
        <section className="inner-tab-table contents-container__1200 px30">
          <div {...getTableProps()} className={`base-table sticky overflow-x-hidden`}>
            <div
              className="header" //
            >
              {headerGroups.map((headerGroup) => (
                <div {...headerGroup.getHeaderGroupProps()} className="base-table__tr">
                  {headerGroup.headers.map((header) => {
                    return (
                      <div
                        {...header.getHeaderProps(header.id !== "rowChecked" ? header.getSortByToggleProps() : undefined)}
                        className={`base-table__th cursor-unset flex-center-start`}
                      >
                        {header.render("Header")}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
            <div {...getTableBodyProps()} className="body max-height500">
              {rows.map((row: any) => {
                prepareRow(row);
                return (
                  <div {...row.getRowProps()} className={`base-table__tr`}>
                    {row.cells.map((cell: any) => {
                      return (
                        <div {...cell.getCellProps()} className={`base-table__td flex-center-start`}>
                          {cell.render("Cell")}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
            {rows.length === 0 && (
              <div className="base-table__tr table-cursor-unset" style={{ width: tableWidth }}>
                <div className="base-table__td w-100 text-center">
                  <div className="w-100">
                    <span>등록된 데이터가 없습니다.</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        {/* <InnerTable data={pendingBillList} columns={billingScheduleColumns} /> */}
        {/* <BaseTable data={[]} columns={billingScheduleColumns} pageIndex={0} totalPages={0} goPage={() => {}} setOrders={() => {}} /> */}
        {/* </article> */}
      </section>
      <section className="base-abstract-modal__btn-wrap">
        <div className="flex-center">
          <BaseButton title="취소" className="color-white mr10" onClick={onClose} />
          <BaseButton title="저장" onClick={onSave} />
        </div>
      </section>
    </>
  );
};

export default ContractBillingScheduleConfirmModal;
